/*
 * @Author: wangyan1
 * @Description:
 * @Date: 2022-04-25 17:07:00
 * @LastEditTime: 2023-12-21 10:45:14
 * @FilePath: /teacher-xkh-web/src/service/common/index-url.js
 */
let baseUrl = ''
if (process.env.NODE_ENV === 'development') {
  baseUrl = '/xkh/teacherapi'
} else {
  baseUrl = '//xkhteacher.aixuexi.com/xkh/teacherapi'
}

export default {
  getBaseData: `${baseUrl}/base/optional/parameter`,
  getGradeList: `${baseUrl}/base/studentInstitutionGradeList`,
  // 教师换组学生-冲突提示 https://yapi.aixuexi.com/project/42/interface/api/196826
  clashQuery: `${baseUrl}/course/clash/query`,
  // 教师换组学生-冲突提示-阅读 https://yapi.aixuexi.com/project/42/interface/api/196829
  clashRead: `${baseUrl}/course/clash/read`,
  // 根据班型获取讲次信息 https://yapi.aixuexi.com/project/42/interface/api/196832
  lessonList: `${baseUrl}/base/lesson/list`,
  // 根据学生userId生成二维码
  getQRcodeStr: `${baseUrl}/guardian/bind/getQRcodeStr`
  // getSubjectAndGrade: `${baseUrl}/api/group/subject/grade`
}
